import { getEnv } from '@schooly/utils/runtime-env';

import { AUTH_APP_BASE_PATH } from 'apps/auth/src/config';

export const SERVER = getEnv('VITE_SERVER') ?? '';
export const SCHOOLY_API_V2_URL = getEnv('VITE_SCHOOLY_API_V2_URL') ?? '';
export const THREAD_API_URL = getEnv('VITE_THREAD_API_URL') ?? '';
export const AUTH_APP_URL =
  getEnv('VITE_OVERRIDE_AUTH_APP_URL') || `${window.location.origin}${AUTH_APP_BASE_PATH}`;
export const APP_DOMAIN = 'https://app.schooly-app.com';
export const DEBUG = import.meta.env.VITE_DEBUG;
export const IS_DEMO = import.meta.env.VITE_DEMO === 'true';
export const IS_DEV = import.meta.env.DEV;
export const SENTRY_DSN = import.meta.env.VITE_SENTRY_DSN;
export const ENV_TYPE = import.meta.env.VITE_ENV_TYPE;
export const SENTRY_ENVIRONMENT_NAME = import.meta.env.VITE_ENVIRONMENT_NAME;
export const SENTRY_TRACES_SAMPLE_RATE = Number(
  import.meta.env.VITE_SENTRY_TRACES_SAMPLE_RATE ?? 0.02,
);
export const SENTRY_PROFILES_SAMPLE_RATE = Number(
  import.meta.env.VITE_SENTRY_PROFILES_SAMPLE_RATE ?? 0.02,
);
export const FEATURE_ALLOW_STUDENT_INVITE =
  import.meta.env.VITE_FEATURE_ALLOW_STUDENT_INVITE === 'true';
export const STREAM_API_KEY = import.meta.env.VITE_STREAM_API_KEY;

const cookieDomain = getEnv('VITE_ORIGIN');
const isLocalhost = cookieDomain === 'localhost';
const cookieSameSite = isLocalhost || IS_DEV ? 'lax' : 'none';
const cookieSecure = !isLocalhost && !IS_DEV;

// Capitalized keys are expected for amplify config
export const AWS_CONFIG = {
  Auth: {
    mandatorySignIn: true,
    region: import.meta.env.VITE_AWS_REGION,
    userPoolId: import.meta.env.VITE_COGNITO_IDENTITY_USER_POOL_ID,
    userPoolWebClientId: import.meta.env.VITE_COGNITO_IDENTITY_USER_POOL_CLIENT_ID,
    identityPoolId: import.meta.env.VITE_COGNITO_IDENTITY_POOL,
    cookieStorage: {
      domain: cookieDomain,
      sameSite: cookieSameSite,
      secure: cookieSecure,
    },
  },
  Storage: {
    bucket: import.meta.env.VITE_PUBLIC_UPLOADS_S3_BUCKET,
    region: import.meta.env.VITE_AWS_REGION,
  },
};

export const DEFAULT_DATE_FORMAT = 'YYYY-MM-DD';

export const {
  VITE_DATE: BUILD_DATE,
  VITE_COMMIT_SHA: COMMIT_SHA,
  VITE_LANGUAGE: LANGUAGE,
} = import.meta.env;

export const FORSED_POPOVER_ZINDEX = 1400;

export const MUI_PRO_LICENSE_KEY =
  '1a1b6e8f3403377f1c40e6221bf61686Tz0xMjc0NTgsRT0xODA2MTA1NTk5MDAwLFM9cHJvLExNPWFubnVhbCxQVj1RMy0yMDI0LEtWPTI=';

export const AMPLITUDE_API_KEY = '1f2097cac9ef4f06779cc7791890532c';
